import React from "react";

import { Permissions } from "@/lib/permissions";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";

import obilazniceModel from "@/models/obilaznice";
import obilaznicaPointModel from "@/models/obilaznica_points";

import ObilaznicaDialog from "./ObilaznicaDialog"
import ObilaznicaPointDialog from "./ObilaznicaPointDialog";

function ObilaznicePage() {
  return (
    <DataCentricPage
      needPermission={[Permissions.Administration]}

      primaryModel={obilazniceModel}
      primaryTitleToken="titles.obilaznice"
      primaryView={"default"}
      primaryAllowAdd={true}
      primaryAllowView={true}
      primaryAllowEdit={true}
      primaryDialogComponent={ObilaznicaDialog}
      primaryDialogForm={"default"}

      secondaryModel={obilaznicaPointModel}
      secondaryTitleToken="titles.kontrolne_tocke"
      secondaryView={"default"}
      secondaryAllowAdd={true}
      secondaryAllowView={true}
      secondaryAllowEdit={true}
      secondaryDialogComponent={ObilaznicaPointDialog}
      secondaryDialogForm={"default"}
      secondaryDialogsUseCombinedPaths={true}

      baseRecordPath={obilazniceModel.apiPath}
      childRecordRelativePath="points"
      geomRelativePath="geom"

      mapId={6}
      mapModel={obilazniceModel}
    />
  );
}

export default ObilaznicePage;
